import { useEffect, useState } from "react"
import { VscAdd } from "react-icons/vsc"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { fetchInstructorCourses } from "../../../services/operations/courseDetailsAPI"
import IconBtn from "../../common/IconBtn"
import CoursesTable from "./InstructorCourses/CoursesTable"

export default function MyCourses() {
    const { token } = useSelector((state) => state.auth)
    const navigate = useNavigate()
    const [courses, setCourses] = useState([])

    // useEffect(() => {
    //     const fetchCourses = async () => {
    //         const result = await fetchInstructorCourses(token)
    //         if (result) {
    //             setCourses(result)
    //         }
    //     }
    //     fetchCourses()
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])
    useEffect(() => {
        const fetchCourses = async () => {
            // 1. Log the token to see if it's actually there
            console.log("DEBUG: Token value is:", token);

            // 2. If token is null/undefined, don't even try the API
            if (!token) {
                console.log("Waiting for token...");
                return;
            }

            try {
                const result = await fetchInstructorCourses(token);
                if (result) {
                    setCourses(result);
                }
            } catch (error) {
                console.error("Failed to fetch courses in component:", error);
            }
        };

        fetchCourses();
    }, [token]);

    return (
        <div>
            <div className="mb-14 flex items-center justify-between">
                <h1 className="text-3xl font-medium text-richblack-5">My Courses</h1>
                <IconBtn
                    text="Add Course"
                    onclick={() => navigate("/dashboard/add-course")}
                >
                    <VscAdd />
                </IconBtn>
            </div>
            {courses && <CoursesTable courses={courses} setCourses={setCourses} />}
        </div>
    )
}